import React from "react";
import { useEffect, useMemo, useState } from "react";
import { ResponseModel } from "model/utilModels/ResponseModel";
import CustomTableGrid from "components/uiComponents/CustomTableGrid";
import { PaginatorModel } from "model/utilModels/PaginatorModel";
import { msgTypes } from "constants/msgTypes";
import { Formik, Form } from "formik";
import FormikControl from "components/wrapperComponents/FormikControl";
import { NewsLetterSubscribersService } from "services/menu/newsLetterSubscribers/NewsLetterSubscribersService";

const NewsLetterSubscribersList = () => {
  const [newsLetterSubscribersList, setNewsLetterSubscribersList] =  useState<ResponseModel | null>(null); 
  const [noRecord, setNoRecord] = useState(false);
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  });

  useEffect(() => {
    getNewsLetterSubscribersList();
  }, [
    pagination.pageNumber,
    pagination.pageSize,
    pagination.filter,
    pagination.orderBy,
    pagination.desc,
  ]);

  // Prepare request body to get news letter list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  };

  //Get News Letter List
  const getNewsLetterSubscribersList = async () => {
    const requestBody = prepareRequest();
    const res = await NewsLetterSubscribersService.getNewsLetterSubscribersList(
      requestBody
    );
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setNewsLetterSubscribersList(res);
    }
  };

  const initialValues = {};
  const onSubmit = () => {
    getNewsLetterSubscribersList();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "emailId",
        header: "Email Id",
        size: 150,
      },
    ],
    []
  );

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(formik) => (
          <Form>
              {newsLetterSubscribersList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control="materialTable"
                  tableColumn={columns}
                  tableData={newsLetterSubscribersList}
                  formikValue={formik}
                  setPagination={setPagination}
                  enableClickToCopy = {true}
                />
              }
            />
          ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default NewsLetterSubscribersList;
